import {
  Box,
  Select,
  Menu,
  Button,
  Divider,
  CloseButton,
  Flex,
  Rating,
  Input,
  Text,
  TextInput,
  Textarea,
  Title,
  Group,
  Tooltip,
  ActionIcon,
  Grid,
  Anchor,
  Badge,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import React, { useEffect, useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblUserReview } from "../../../model/TblUserReview";
import { useForm } from "@mantine/form";
import { title } from "process";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import { _localization } from "../../../config/location";
import { styleTableMantine } from "../../../_base/_const/_constVar";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import {
  IconCircleCheckFilled,
  IconDownload,
  IconEye,
  IconSearch,
  IconTag,
  IconTimeDuration15,
  IconTrash,
} from "@tabler/icons-react";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { useLocation } from "react-router-dom";
import DetailCollectionRecruitment from "./DetailCollectionRecruitment";
import { Worker, Viewer, Icon } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import DeleteView from "./DeleteView";
import UpdateStatus from "./UpdateStatus";
import { DatePickerInput } from "@mantine/dates";
import { tuyenDung } from "../../../model/TblTuyenDung";

const CollectionRecruitment = () => {
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [datas, setDatas] = useState<tuyenDung[]>([]);
  const [total, setTotal] = useState(0);
  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectIds, setSelectIds] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
      FromDate: _searchJson && checkedPinSearch ? _searchJson?.FromDate : "",
      ToDate: _searchJson && checkedPinSearch ? _searchJson?.ToDate : "",
      Status: _searchJson && checkedPinSearch ? _searchJson?.Status : "",
      CvStatus: _searchJson && checkedPinSearch ? _searchJson?.CvStatus : "",
    },
  });

  const dataPosition = new Map(
    datas?.map((item) => [item.position, item.position]) || []
  );

  const isTrue = (v: any) => v === true || v === "true" || v === 1 || v === "1";

  const columns = React.useMemo<MRT_ColumnDef<tuyenDung>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 100,
      },
      {
        accessorKey: "fullName",
        header: "Người gửi",
        size: 250,
      },
      {
        accessorKey: "phone",
        header: "Số điện thoại",
        size: 150,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 200,
      },
      {
        accessorKey: "position",
        header: "Vị trí ứng tuyển",
        size: 250,
      },
      {
        accessorKey: "createdDate",
        header: "Thời gian",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "status",
        header: "Trạng thái tuyển dụng",
        size: 200,
        Cell: ({ row }) => {
          return (
            <UpdateStatus
              onSearch={() => fetchDataUserReview()}
              id={row.original.id}
              status={row.original.status}
            />
          );
        },
      },
      {
        accessorKey: "cvStatus",
        header: "Trạng thái xem CV",
        mantineTableBodyCellProps: ({ row }) => ({
          style: isTrue(row.original.cvStatus)
            ? { backgroundColor: "#e6fcf5" }
            : undefined,
        }),
        size: 175,
        Cell: ({ row }) => {
          const viewed = isTrue(row.original.cvStatus);
          return (
            <>
              {viewed ? (
                <Badge
                  color="green"
                  variant="light"
                  leftSection={<IconCircleCheckFilled size={14} />}
                >
                  Đã xem
                </Badge>
              ) : (
                <Badge color="gray" variant="outline">
                  Chưa xem
                </Badge>
              )}
            </>
          );
        },
      },
      {
        accessorKey: "actions",
        header: "Thao tác",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        size: 110,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip label="Xem CV">
              <ActionIcon
                variant="light"
                color="blue"
                onClick={() =>
                  handleViewCV(row.original.id, row.original.fullName)
                }
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Tải CV">
              <ActionIcon
                variant="light"
                color="green"
                onClick={() =>
                  handleDownloadCV(row.original.id, row.original.fullName)
                }
              >
                <IconDownload size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                color="red"
                onClick={async () => {
                  await deleteItem(row.original.id);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [datas]
  );

  // Cập nhật trạng thái CV khi xem/tải
  const updateCvStatus = async (id: string) => {
    try {
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      const url = `/TblTuyenDung/edit-cv-status`;
      await repository.post(url, { ids: [id], cvStatus: "true" });

      // Cập nhật ngay trên UI
      setDatas((prev) =>
        (prev ?? []).map((it: any) =>
          it.id === id ? { ...it, cvStatus: "true" } : it
        )
      );
    } catch (error) {
      console.error("Lỗi cập nhật cvStatus:", error);
    }
  };

  const handleDownloadCV = async (id: string, fullName: string) => {
    try {
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      const url = `/TblTuyenDung/download-cv/${id}`;

      const response = await repository.get(url, {
        responseType: "blob",
      });

      // Tạo blob URL và trigger download
      const blob = new Blob([response]);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", `CV_${fullName}.pdf`);
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      // Cập nhật trạng thái CV đã xem
      await updateCvStatus(id);

      NotificationExtension.Success("Tải CV thành công");
    } catch (error) {
      console.error("Lỗi khi tải CV:", error);
      NotificationExtension.Fails("Không thể tải CV. Vui lòng thử lại sau.");
    }
  };

  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const handleViewCV = async (id: string, fullName: string) => {
    try {
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      const url = `/TblTuyenDung/download-cv/${id}`;
      const response = await repository.get(url, {
        responseType: "blob",
      });

      const blob = new Blob([response], { type: "application/pdf" });
      const pdfUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      modals.open({
        title: `CV - ${fullName}`,
        size: "100vw",
        children: (
          <div style={{ height: "600px", width: "800px" }}>
            <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
            >
              <Viewer
                fileUrl={pdfUrl}
                plugins={[defaultLayoutPluginInstance]}
              />
            </Worker>
          </div>
        ),
        onClose: () => {
          window.URL.revokeObjectURL(pdfUrl);
        },
      });

      // Cập nhật trạng thái CV đã xem
      await updateCvStatus(id);
    } catch (error) {
      console.error("Lỗi khi xem CV:", error);
      NotificationExtension.Fails("Không thể xem CV. Vui lòng thử lại sau.");
    }
  };

  const fetchDataUserReview = async () => {
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    const search = formSeachInput.getValues();
    try {
      let urlSearch = `/TblTuyenDung/get-list?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;
      if (search.KeySearch) {
        urlSearch += `&KeySearch=${search.KeySearch.trim()}`;
      }
      if (search.FromDate) {
        urlSearch += `&FromDate=${search.FromDate}`;
      }
      if (search.ToDate) {
        urlSearch += `&ToDate=${search.ToDate}`;
      }
      if (search.Status) {
        urlSearch += `&Status=${search.Status}`;
      }
      if (search.CvStatus) {
        urlSearch += `&CvStatus=${search.CvStatus}`;
      }
      let callapi = await repository.get<MessageResponse<any>>(urlSearch);
      if (callapi && callapi.success) {
        setDatas(callapi?.data ?? []);
        setRowCount(callapi?.totalCount ?? 0);
        setTotal(callapi?.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setDatas([]);
        setRowCount(0);
        setIsLoading(false);
      }
      return callapi?.data;
    } catch (error: any) {
      setDatas([]);
      setIsError(true);
      return null;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify(formSeachInput.getValues())
      );
    }
  };

  const detailData = (id: number) => {
    modals.open({
      title: "Chi tiết đánh giá",
      children: (
        <>
          <DetailCollectionRecruitment id={id} />
        </>
      ),
      size: "lg",
    });
  };

  const fetchData = async () => {
    await fetchDataUserReview();
  };

  const deleteItem = (idItem: string) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa hồ sơ ứng viên</Title>
        </>
      ),
      children: <DeleteView onSearch={() => fetchData()} idItem={[idItem]} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  const table = useMantineReactTable({
    columns,
    data: datas,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableTopToolbar: false,
    enablePagination: true,
    localization: _localization,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    // enableRowSelection: true,
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT"],
        right: ["status", "cvStatus", "actions"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    getRowId: (row) => row.id,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (250 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  return (
    <>
      <Flex
        gap="md"
        justify={"space-between"}
        align="center"
        direction="row"
        wrap="wrap"
        w={"100%"}
      >
        <BreadCrumb></BreadCrumb>
      </Flex>
      <Divider my="sm" />
      <Grid justify="space-between" align="center" mb={10}>
        <Grid.Col span="auto">
          <Group gap="sm">
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />

            <Select
              searchable
              clearable
              placeholder="Trạng thái tuyển dụng"
              data={[
                { value: "chodanhgia", label: "Chờ đánh giá" },
                { value: "phuhop", label: "Phù hợp" },
                { value: "phongvan", label: "Đang phỏng vấn" },
                { value: "dagui", label: "Đã gửi offer" },
                { value: "datuyen", label: "Đã tuyển" },
                { value: "khongphuhop", label: "Không phù hợp" },
              ]}
              key={formSeachInput.key("Status")}
              {...formSeachInput.getInputProps("Status")}
            />

            <Select
              searchable
              clearable
              placeholder="Trạng thái CV"
              // leftSection={<IconTag color="#15aabf" />}
              data={[
                { value: "true", label: "Đã xem" },
                { value: "false", label: "Chưa xem" },
              ]}
              key={formSeachInput.key("CvStatus")}
              {...formSeachInput.getInputProps("CvStatus")}
            />

            {/* <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                formSeachInput.getValues()?.FromDate &&
                formSeachInput.getValues()?.FromDate?.length > 0
                  ? new Date(formSeachInput.getValues()?.FromDate)
                  : null
              }
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              onChange={(date) => {
                formSeachInput.setValues((prev) => ({
                  ...prev,
                  FromDate: date ? formatDateNotTimeZone(date) : "",
                }));
              }}
              clearable
            />

            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                formSeachInput.getValues()?.ToDate &&
                formSeachInput.getValues()?.ToDate?.length > 0
                  ? new Date(formSeachInput.getValues()?.ToDate)
                  : null
              }
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              onChange={(date) => {
                formSeachInput.setValues((prev) => ({
                  ...prev,
                  ToDate: date ? formatDateNotTimeZone(date) : "",
                }));
              }}
              clearable
            /> */}
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchDataUserReview();
              }}
            >
              Tìm kiếm
            </Button>
          </Group>
        </Grid.Col>
      </Grid>
      <MantineReactTable table={table} />
    </>
  );
};

export default CollectionRecruitment;
